import styled from "styled-components";
import { Modal as NotesModal } from "notes";

export const Modal = ({ open, setOpen, children }) => {
  return (
    <ModalBackground open={open}>
      <ModalWrapper size="large" open={open} setOpen={setOpen}>
        <ModalContainer>{children}</ModalContainer>
      </ModalWrapper>
    </ModalBackground>
  );
};

// ======== MODAL ======== //

const ModalBackground = styled.div`
  ${(props) =>
    props.open &&
    `
    background-color: rgb(0 0 0 / 75%);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

const ModalWrapper = styled(NotesModal)`
  padding: 65px 40px;
  min-height: unset;
  width: 100%;
  display: flex;
  background-color: #000;
  line-height: 1.5;
  margin: 44px 0;

  & > svg {
    border: 1px solid #fff;
    border-radius: 25px;
    padding: 5px;

    & > path {
      fill: #fff;
    }
  }

  & > svg:hover {
    background-color: #fff;

    & > path {
      fill: #000;
    }
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex: unset;
    margin: auto;
  }

  @media (max-width: 490px) {
    padding: 65px 20px;

    & > svg {
      right: 4%;
    }
  }
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
